import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerPatri = styled(motion.div)`
    width: calc(50% - 20px);
    height: calc(100vh - 200px);
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 15px;
    position: relative;

    &[data-segmento="Patrimônios"] {
        width: 99%;
        min-width: 99%;
        height: calc(100vh - 200px);
    }

    p.ContainerPatri__title {
        font-weight: 600;
        color: var(--text-color);
        width: 100%;
        font-size: 14px;
        margin: 0;
        padding: 0;
    }

    button.ContainerPatri__unidade {
        position: absolute;
        top: 15px;
        right: 10px;
        font-weight: 500;
        font-size: 12px;
        display: flex;
        align-items: center;
        gap: 5px;
        border: none;
        background: transparent;
        cursor: pointer;
        text-transform: capitalize;

        :hover {
            background: var(--hover-color);
        }
    }
    div.ContainerPatri__list {
        width: 100%;
        margin-top: 10px;
        height: calc(100% - 30px);
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        padding-right: 10px;

        button.ContainerPatri__list__item {
            width: 100%;
            height: 52px;
            margin: 5px 0px;
            border-radius: 10px;
            border: thin solid var(--border-color);
            background: transparent;
            display: flex;
            align-items: center;
            cursor: pointer;

            div.ContainerPatri__list__item__name {
                width: 35%;
                height: 80%;
                display: flex;
                align-items: center;
                font-size: 12px;
                font-weight: 600;
                box-sizing: border-box;
                padding-right: 15px;
                border-right: 2px solid green;
                text-align: left;
                line-height: 15px;
                text-transform: capitalize;
            }
            div.ContainerPatri__list__item__values {
                width: 65%;
                height: 80%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 10px;
                box-sizing: border-box;
                padding: 0px 5px;

                div.ContainerPatri__list__item__values__item {
                    width: 80px;
                    height: 100%;
                    border-radius: 5px;
                    text-transform: capitalize;

                    :is([data-hightlight = true]) {
                        background: #98ca81;
                        color: #227242;

                        span {
                            color: #227242;
                        }
                    }

                    span {
                        margin: 0;
                        padding: 0;
                        font-size: 10px;
                        font-weight: 500;
                        color: var(--text-color-light);
                    }
                    p {
                        margin: 0;
                        padding: 0;
                        font-size: 11px;
                        font-weight: 600;
                        margin-top: -5px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
    div.ContainerPatri__opt_unidade {
        width: 200px;
        box-sizing: border-box;
        padding: 10px;
        background: #fff;
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
        z-index: 100;

        button.ContainerPatri__opt_unidade__item {
            width: 100%;
            height: 40px;
            border-radius: 5px;
            border: none;
            background: #fff;
            color: var(--text-color);
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;
            text-align: left;

            :hover {
                background: #d5ffe8;
            }
        }
    }
`;